import { ObjectMapper } from 'json-object-mapper';
import { IModel } from './IModel';
import { Model } from './model';

export class CompanyGroupEmailSettingModel
  extends Model
  implements IModel<CompanyGroupEmailSettingModel>
{
  userName: string = '';
  email: string = '';
  host: string = '';
  password: string = '';
  port: number = 0;
  enableSsl: boolean = false;
  isPendingConfirmation: boolean = false;

  static create(input: any): CompanyGroupEmailSettingModel {
    return ObjectMapper.deserialize<CompanyGroupEmailSettingModel>(
      CompanyGroupEmailSettingModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
